const animations = () => {
  /*
  // Set a parent container as "loaded" when a child element loads
  window.elementLoaded = (element) => {
    $(element).closest('.AnimateOnLoad').addClass('AnimateOnLoad--loaded');
  };

  /*
  // Check for any "preloaded" images and basically do the same thing as the elementLoaded function above.
  // These are images that loaded before this JS file could even execute, which are handled by some inline JS in theme.liquid
  $('.AnimateOnLoad--preloaded').each((i, element) => {
    // If it's preloaded, let it animate in with nice looking delays like other animations
    $(element).closest('.AnimateOnLoad').addClass('Animate');
    setTimeout(() => {
      $(element).closest('.AnimateOnLoad').addClass('AnimateOnLoad--loaded');
    }, 1);
  });
  */

  /*$(window).on('scroll', () => {
    const scroll_top = $(window).scrollTop();
    const window_height = $(window).height();
    const trigger = (window_height * 0.9) + scroll_top;
    let delay = 0;

    $('.animate:not(.animate--animated), .animate-when-loaded:not(.animate--animated)').each((i, element) => {
      const $element = $(element);

      if ($element.offset().top + $element.height() < scroll_top) {
        $element.css('animation-delay', '0ms').css('transition-delay', '0ms').addClass('animate--animated');
      } else if ($element.offset().top <= trigger) {        
        $element.css('animation-delay', `${delay}ms`).css('transition-delay', `${delay}ms`).addClass('animate--animated');

        delay += 50;
      }
    });
  });*/

  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const trigger = (windowHeight * 0.9) + scrollTop;
    let delay = 0;
  
    const elements = document.querySelectorAll('.animate:not(.animate--animated), .animate-when-loaded:not(.animate--animated)');
    
    elements.forEach(element => {
      const rect = element.getBoundingClientRect();
      const elementTop = rect.top + scrollTop;

      if (elementTop + element.offsetHeight < scrollTop) {
        element.style.animationDelay = '0ms';
        element.style.transitionDelay = '0ms';
        element.classList.add('animate--animated');
      } else if (elementTop <= trigger) {
        element.style.animationDelay = `${delay}ms`;
        element.style.transitionDelay = `${delay}ms`;
        element.classList.add('animate--animated');
        
        delay += 50;
      }
    });
  });
};

// Animate the elements of container without having to trigger a scroll event
const animateNoScroll = (container) => {
  if (!container) {
    return;
  }
  
  const elements = container.querySelectorAll('.animate:not(.animate--animated), .animate-when-loaded:not(.animate--animated)');
  let delay = 0;

  elements.forEach((element, index) => {
    element.style.animationDelay = `${delay}ms`;
    element.style.transitionDelay = `${delay}ms`;
    element.classList.add('animate--animated');
    
    delay += 50;
  });
};

const triggerWindowEvent = (eventName) => {
  try {
    const event = new Event(eventName, {
      bubbles: true,
      cancelable: true,
      composed: true
    });
    window.dispatchEvent(event);
  } catch (error) {
    console.error(`Failed to dispatch ${eventName} event:`, error);
  }
};

const animate = () => {
  triggerWindowEvent('scroll');
  triggerWindowEvent('resize');
};

export { animations, animate, animateNoScroll };
